<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Cadastro do cargo
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="role.display_name"
            prepend-icon="mdi-account"
            label="Nome do cargo"
            :rules="rulesName"
            @input="inputCodigo"
          />
          <v-text-field
            v-model="role.name"
            dense
            filled
            prepend-icon="mdi-qrcode"
            label="Código"
          />
        </v-form>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import slugify from 'slugify'

export default {

  data: () => ({
    rulesName: [
      value => !!value || 'Nome é obrigatório.',
      value => (value && value.length > 2) || 'Min 3 caracteres'
    ],
    role: {
      display_name: undefined,
      name: undefined
    }
  }),
  created () {
  },
  methods: {
    inputCodigo () {
      this.role.name = slugify(this.role.display_name).toLowerCase()
    },
    validate () {
      return this.$refs.form.validate()
    },
    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      const validate = await this.validate()
      if (validate === false) {
        return false
      }
      const data = {
        display_name: this.role.display_name,
        name: this.role.name
      }
      this.$emit('resolve', data)
    }
  }
}
</script>
